import { useSelector } from 'react-redux';
import { RootState } from 'data';
import { ProjectTemplateActiveRecord } from 'data/templates/projects/types';

const getActiveRecord = (
  state: RootState,
): ProjectTemplateActiveRecord | undefined =>
  state.templates.project.activeRecord;

export const useActiveRecord = (): ProjectTemplateActiveRecord | undefined => {
  return useSelector(getActiveRecord);
};
